import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import debounce from "lodash.debounce";
import { useSearchParams } from "react-router";
import { fetchDiagnosis, fetchServCategoryXServCdRange, fetchServiceCategoryHistFact, fetchServiceCodeRangeFact, fetchServicesAll, fetchServiceTypeNames } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import Select from 'react-select';

const limit = 20
const DiagnosisCodes = () => {

    const [searchParams] = useSearchParams();
    const [searchValue, setSearchValue] = useState(() => searchParams.get("search") || "");
    const [decouncedSearchValue, setDecouncedSearchValue] = useState(() => searchParams.get("search")?.trim() || undefined);


    const { ref, inView } = useInView();

    const { data, error, fetchNextPage, hasNextPage, isLoading, isPending, isFetching, isFetchingNextPage, status, refetch } = useInfiniteQuery({
        queryKey: ["diagnosisCodes", limit, decouncedSearchValue],
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {};

            if (decouncedSearchValue) {
                params.searchText = decouncedSearchValue;
            }

            return await fetchDiagnosis({ ...params, limit });
        },

        select: (data) => {
            //   console.log({ data });
            return { count: data.pages?.[0]?.count, rows: data.pages.map((page) => page.rows).flatMap((x) => x) };
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
            const hasMore = lastPage?.rows?.length === limit;

            if (!hasMore) return undefined;
            return {
                offset: pages.reduce((accum, page) => {
                    return accum + page.rows.length;
                }, 0),
            };
        },
        staleTime: 0,
        enabled: true,
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    const columns = ['diagnosisCode', 'standardizedDiagnosisCode', 'diagnosisShortDesc', 'diagnosisLongDesc', 'diagnosisTypeName'];

    return (
        <div className={'container '}>
            <p className='title'>Diagnosis Codes  ( {data?.count || 0} )</p>
            <p className="sub-title">ICD (International Classification of Diseases) diagnosis codes </p>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                    <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder="search..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />
                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem", }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        setDecouncedSearchValue("");
                        setSearchValue("");
                    }}
                >
                    Clear filters
                </p>

            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"diagnosis-code"}
                        columns={columns}
                        items={data?.rows}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onEditHandler={onEditHandler}
                        // onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}

        </div>
    )
}

export default DiagnosisCodes